import { useCallback, useEffect, useState } from 'react';
import { FetchConfig } from '../../redux/apiTypes';
import requestGetUnreadMessages from './requestGetUnreadMessages';

interface Counts {
  unreadOrders: number;
  unreadOffers: number;
}

const initialCounts: Counts = {
  unreadOrders: 0,
  unreadOffers: 0,
};

const useExtNcUnreadCountsLogic = (userIsLoggedIn: boolean, fetchConfig: FetchConfig) => {
  const [{
    unreadOrders,
    unreadOffers,
  }, setCounts] = useState<Counts>(initialCounts);
  const unreadTotal = unreadOrders + unreadOffers;

  const updateCounts = useCallback(async () => {
    const chainId = fetchConfig.xChain;
    const chains = await requestGetUnreadMessages(fetchConfig);
    const currentChainCounts = chains.find(chain => chain.chain_id === chainId);

    if (currentChainCounts) {
      setCounts({
        unreadOrders: currentChainCounts.count_of_orders_with_unread_msgs,
        unreadOffers: currentChainCounts.count_of_marketing_unread_msgs,
      });
    }

  }, [fetchConfig]);

  useEffect(() => {
    if (userIsLoggedIn) {
      void updateCounts();

      window.addEventListener('focus', updateCounts);

      return () => window.removeEventListener('focus', updateCounts);
    } else {
      setCounts(initialCounts);
    }
  }, [updateCounts, userIsLoggedIn]);

  return {
    unreadOrders,
    unreadOffers,
    unreadTotal,
    updateCounts,
  };
};

export default useExtNcUnreadCountsLogic;
